/** Helpers del envío a Binary en lote (compartidos por Alta Grupos y Rechazados). */

export function fmtNum(n: number): string {
  return n.toLocaleString('es-AR');
}

/** Mensaje legible del error que devolvió el backend al disparar el envío. */
export function mensajeDeErrorEnvio(e: unknown): string {
  const err = e as { response?: { data?: { message?: string } }; message?: string };
  return err?.response?.data?.message ?? err?.message ?? 'No se pudo iniciar el envío.';
}
